import React, { useCallback, useMemo, useContext } from 'react';
import compose from '../../utils/compose';
import SelectInput from '../../Inputs/SelectTypeahead/SelectTypeahead';
import wrapSchemaWidget from './wrapSchemaWidget';
import wrapUiDisabledWidget from './wrapUiDisabledWidget';
import SizeByOptionsContext from './SizeByOptionsContext';
import ThemeContext from '../../ThemeContext';
function eventToValue(e) {
  var result = null;
  if (Array.isArray(e) && e.length > 0) {
    result = e.map(function (val) {
      return val.value;
    });
  } else if (e !== null) {
    result = e.value;
  }
  return result === null ? undefined : result;
}

// "special" number for borders, padding, margin, control for opening menu
var _minWidthOffset = 30.65;
function _calculateMinWidth(enumOptions, theme) {
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');
  var minWidth = 0;
  context.font = theme === 'ripple' ? 'normal 14px "Inter"' : 'normal 13px "Inter"';
  enumOptions.forEach(function (opt) {
    var metrics = context.measureText(opt.label);
    if (metrics.width > minWidth) {
      minWidth = Math.ceil(metrics.width);
    }
  });
  return minWidth > 0 ? minWidth + _minWidthOffset + (theme === 'ripple' ? 45 : 0) : minWidth;
}
function _getCustomStyles(sizeByOptions, enumOptions, theme) {
  var result = {};
  if (sizeByOptions) {
    var minWidth = _calculateMinWidth(enumOptions, theme);
    if (minWidth > 0) {
      result = {
        'min-width': "".concat(minWidth, "px")
      };
    }
  }
  return result;
}
export function makeSelectWidget(Component) {
  return function (props) {
    var id = props.id,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      options = props.options;
    var enumOptions = options.enumOptions;
    var sizeByOptions = useContext(SizeByOptionsContext);
    var handleChange = useCallback(function (e) {
      onChange(eventToValue(e));
    }, [onChange]);
    var handleFocus = useCallback(function () {
      onFocus && onFocus(id, value);
    }, [onFocus, id, value]);
    var handleBlur = useCallback(function () {
      onBlur && onBlur(id, value);
    }, [onBlur, id, value]);
    var styl = useMemo(function () {
      var theme = useContext(ThemeContext);
      return _getCustomStyles(sizeByOptions, enumOptions, theme);
    }, [sizeByOptions, enumOptions]);
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      style: styl,
      options: options.groupedOptions || enumOptions || [],
      value: value
    }));
  };
}
export default compose(wrapUiDisabledWidget, wrapSchemaWidget)(makeSelectWidget(SelectInput));